import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

interface INavigationButtonsProps {
  HANDLE_NEXT_CLICK: () => void;
  HANDLE_PREVIOUS_CLICK: () => void;
  disableBackward?: boolean;
  disableForward?: boolean;
  IS_FINAL_STEP?: boolean;
  IS_STARTING_SLIDE?: boolean;
}

export const NavigationButtons = (props: INavigationButtonsProps) => {
  const {
    IS_STARTING_SLIDE,
    HANDLE_NEXT_CLICK,
    IS_FINAL_STEP,
    HANDLE_PREVIOUS_CLICK,
    disableBackward = false,
    disableForward = false,
  } = props;

  return (
    <>
      {IS_STARTING_SLIDE ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            justifyContent: "flex-start",
          }}
        >
          <IconButton
            onClick={HANDLE_NEXT_CLICK}
            disabled={disableForward}
            sx={{
              background: disableForward ? "#E0E0E0" : "#C8D2E1",
            }}
            color="primary"
          >
            <ArrowForward />
          </IconButton>
        </Box>
      ) : (
        <>
          {!IS_FINAL_STEP ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
                justifyContent: "flex-start",
              }}
            >
              <IconButton
                onClick={HANDLE_PREVIOUS_CLICK}
                disabled={disableBackward}
                sx={{
                  background: disableBackward ? "#E0E0E0" : "#F2F2F2",
                }}
              >
                <ArrowBack />
              </IconButton>

              <IconButton
                onClick={HANDLE_NEXT_CLICK}
                disabled={disableForward}
                sx={{
                  background: disableForward ? "#E0E0E0" : "#C8D2E1",
                }}
                color="primary"
              >
                <ArrowForward />
              </IconButton>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
                justifyContent: "flex-start",
              }}
            >
              <IconButton
                onClick={HANDLE_PREVIOUS_CLICK}
                disabled={disableBackward}
                sx={{
                  background: disableBackward ? "#E0E0E0" : "#F2F2F2",
                }}
              >
                <ArrowBack />
              </IconButton>
            </Box>
          )}
        </>
      )}
    </>
  );
};
